<template>
  <div class="login">
    <van-nav-bar
      class="head"
      title="登录"
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="login-con">
      <!-- <img class="img" src="./imgs/login.png" alt="登录"> -->
      <div class="content">
        <van-tabs v-model="active">
          <van-tab title="邮箱登录" name="email"></van-tab>
          <van-tab title="手机登录" name="phone"></van-tab>
        </van-tabs>
        <van-form
          validate-first
          @failed="onFailed"
          @submit="onSubmit">
          <van-field
            v-if="active=='email'"
            v-model="email"
            name="email"
            placeholder="请输入邮箱"
            :rules="[{ pattern: /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/, message: '邮箱格式有误，请重试' }]"
          />
          <van-field
            v-if="active=='phone'"
            v-model="phone"
            name="phone"
            placeholder="请输入手机号"
            :rules="[{ pattern: /^1[0-9]{10}$/, message: '手机号格式有误，请重试' }]"
          />
          <van-field
            v-model="passWord"
            type="password"
            name="passWord"
            placeholder="请输入密码"
            :rules="[{ required: true, message: '请输入密码' }]"
          />
          <div style="margin: 16px;">
            <van-button round block type="info" native-type="submit">登录</van-button>
          </div>
          <div class="togo">
            <router-link :to="{ path:'/user/register', query: {type:0}}">注册账号</router-link>
            <router-link :to="{ path:'/user/register', query: {type:1}}">忘记密码</router-link>
          </div>
        </van-form>
      </div>
      <div class="tips">仅支持普通用户登录</div>
    </div>
  </div>
</template>

<script>
import { loginForH5 } from '@/api/user';
import {
  setStore,
  setStoreSession,
} from '@/utils/utils';
export default {
  name: 'login',
  data() {
    return {
      active: 'email',
      email: '',
      phone: '',
      passWord: '',
    };
  },
  watch: {
  },
  methods: {
    onClickLeft() {
      window.history.back(-1)
    },
    onFailed(errorInfo) {
      // console.log('failed', errorInfo);
      this.$toast(errorInfo.errors[0].message);

    },
    onSubmit(values) {
      // console.log('submit', values);
      loginForH5(values).then((res) => {
        if (res.data.code === 200) {
          this.$toast.success(res.data.message);
          let data = res.data.result;
          setStore('loginRole', data.loginRole);
          setStore('menus', data.menus);
          setStore('token', data.token);
          setStore('userInfo', data.userInfo);
          setStoreSession('haslogin', 'yes');
          this.$router.push({ path: '/' });
        } else {
          this.$toast.fail(res.data.message);
        }
      });
    },
  },
  mounted() {

  },
  updated() {
  },
};
</script>

<style scoped lang="scss">
.login{
  height: 100%;
  box-sizing: border-box;
  padding-top: 50px;
  .head{
    width: 100%;
    height: 50px;
    line-height: 50px;
    font-size: 20px;
    font-weight: 500;
    color: #333333;
    margin-top: -50px;
    text-align: center;
    background: #fff;
  }
  ::v-deep .van-nav-bar .van-icon{
    color: #333;
  }
  .login-con{
    width: 100%;
    // height: 100%; 
    background: url('./imgs/login.png') no-repeat;
    background-size: 100%; 
    flex-direction: column;
    align-items: center;
    // background-color: #fff;
    display: flex;
    position: relative;
    .img{
      top: 0;
      width: 100%;
      height: 200px;
    }
    .content{
      width: 90%;
      // height:60%;
      margin-top: 120px;
      background: #FFFFFF;
      box-shadow: 0px 10px 40px 0px rgba(223, 223, 223, 0.91);
      border-radius: 16px;
      ::v-deep .van-tabs__wrap{
        height: 60px;
        border-radius: 16px;
      }
      ::v-deep .van-tab{
        font-size: 18px;
        margin-top: 10px;
        border-bottom: 1px solid rgba(223, 223, 223, 0.91);
      }
      ::v-deep .van-tab--active{
        color: #376BFF;
      }
      ::v-deep .van-form{
        padding: 30px 20px;
        .van-field__control{
          height: 45px;
          border-radius: 22px;
          padding: 0 17px;
          background: #F8F8F8;
        }
        .van-button{
          height: 45px;
          border-radius: 22px;
          background: linear-gradient(90deg, #3790FF, #376BFF);
          box-shadow: 0px 20px 14px 0px rgba(102, 174, 228, 0.18);
        }
      }
      .togo{
        display: flex;
        justify-content: space-around;
        margin-top: 20px;
        a{
          color: #999999;
          line-height: 10px;
          font-size: 12px;
          font-weight: 400;
        }
      }
    }
    .tips{
      width: 100%;
      height: 20px;
      text-align: center;
      color: #999999;
      line-height: 20px;
      font-size: 12px;
      font-weight: 400;
      margin-top: 5px;
    }
  }
}
</style>
